/**
 * General note charting entry DTOs
 * Extracted from src/services/patientmr/charting.service.ts
 */

import { BaseEntryData } from './chart-entry.dto';

/** Phase 18 M6: INTERNAL entries stay in the record but are left out of family and external copies */
export const ENTRY_VISIBILITIES = ['CHART', 'INTERNAL'] as const;
export type EntryVisibility = typeof ENTRY_VISIBILITIES[number];

/** Phase 18 M13 */
export const NOTE_CATEGORIES = ['GENERAL', 'TEACHING', 'MD_NOTIFICATION', 'NO_CARE', 'HANDOFF', 'SUPERVISORY'] as const;
export type NoteCategory = typeof NOTE_CATEGORIES[number];

/** Phase 19 F22 */
export const TEACHING_METHODS = ['DEMONSTRATION', 'VERBAL', 'WRITTEN', 'VIDEO'] as const;
export type TeachingMethod = typeof TEACHING_METHODS[number];
export const TEACHING_UNDERSTANDING = ['VERBALIZED', 'RETURN_DEMONSTRATION', 'NEEDS_REINFORCEMENT'] as const;
export type TeachingUnderstanding = typeof TEACHING_UNDERSTANDING[number];

/** Phase 19 F22: required when category is TEACHING */
export interface TeachingRecord {
  subject: string;
  learner: string;
  method: TeachingMethod;
  /** 1–480 */
  durationMinutes: number;
  understanding: TeachingUnderstanding;
}

/**
 * General clinical note data structure
 */
export interface GeneralNoteData extends BaseEntryData {
  note: string;
  /** Older entries may hold '' (read as GENERAL) */
  category?: NoteCategory | '';
  followUpNeeded?: boolean;
  visibility?: EntryVisibility;
  teaching?: TeachingRecord;
  imageBase64Array?: string[];
}


/**
 * Supervisor addendum (Phase 9C): added by a supervisor or QA reviewer, never changes the original
 */
export interface AddendumData extends BaseEntryData {
  note: string;
  refEntryId?: string;
  visibility?: EntryVisibility;
}
